import React from 'react';


import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import Menu from '@mui/material/Menu';
import Container from '@mui/material/Container';
import Avatar from '@mui/material/Avatar';
import { ThemeProvider,Tooltip} from '@mui/material';
import { Link, NavLink } from 'react-router-dom';
import { Image } from './gadgets';
import {FaCaretSquareDown } from 'react-icons/fa';
import Theme from './thene';
const {img}=Image
const Header2=()=> {
  const [anchorElNav, setAnchorElNav] = React.useState(null);

  const handleOpenNavMenu = (event) => {
    setAnchorElNav(event.currentTarget);
  };


  const handleCloseNavMenu = () => {
    setAnchorElNav(null);
  };

  

  return (
    <ThemeProvider theme={Theme}>

    <AppBar >
      <Container maxWidth="xl">
        <Toolbar disableGutters>
          <Typography
            variant="h6"
            noWrap
            sx={{
              mr: 2,
              display: { xs: 'none', md: 'flex' },
              fontFamily: 'monospace',
              fontWeight: 700,
              color: 'inherit',
              textDecoration: 'none',
              
            }}
          >
            <Link  to='/'>
            
            KENNETH ART.
            </Link>
          </Typography>

          <Box sx={{ flexGrow: 1, display: { xs: 'flex', md: 'none' } }}>
            <IconButton
              size="large"
              aria-label="account of current user"
              aria-controls="menu-appbar"
              aria-haspopup="true"
              onClick={handleOpenNavMenu}
              color="inherit"
                      >
                         <FaCaretSquareDown className='FaBars'/>
            </IconButton>
            <Menu
              id="menu-appbar"
              anchorEl={anchorElNav}
              anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'left',
              }}
              keepMounted
              transformOrigin={{
                vertical: 'top',
                horizontal: 'left',
              }}
              open={Boolean(anchorElNav)}
              onClose={handleCloseNavMenu}
              sx={{
                display: { xs: 'block', md: 'none' },
              }}
            >
              <div className='navlink'>

             <NavLink   to='/services' onClick={handleCloseNavMenu}>Market Place</NavLink>
             <NavLink to='/products'  onClick={handleCloseNavMenu}>Products</NavLink>
             {/* <NavLink   to='/market' onClick={handleCloseNavMenu}>Market</NavLink> */}
              </div>
            </Menu>
          </Box>
          <Typography
            variant="h5"
            noWrap
            sx={{
              mr: 2,
              display: { xs: 'flex', md: 'none' },
              flexGrow: 1,
              fontFamily: 'monospace',
              fontWeight: 700,
              color: 'inherit',
              textDecoration: 'none',
            }}
          >
            <Link to='/'>
            
            KENNETH ART.
            </Link>
          </Typography>
          <Box sx={{ flexGrow: 1, display: { xs: 'none', md: 'flex' } }}>
            <div className='navlink2'>

             <NavLink to='/services'>Market Place</NavLink>
             <NavLink to='/products'>Products</NavLink>
             {/* <NavLink to='/market'>Market</NavLink> */}
              </div>
          </Box>
          <Link to='/profile'>
            
          <Box sx={{ flexGrow: 0 }}>
            <Tooltip title="Open profile">
             
                <Avatar alt="Kenny Sharp" src={img} />
            </Tooltip>
          
          </Box>
              </Link>
        </Toolbar>
      </Container>
    </AppBar>
    </ThemeProvider>
  );
}
export default Header2;
